import { useContext } from "react";
import { AuthContext } from "../../../../context/AuthContext";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import Table from "../../../../components/Table";
import { SentinelOneThreatscolumns } from "../../../../components/headerContent";
import RowThreats from "./RowtThreats";
import Loader from "../../../../components/Loader";
import { useTranslation } from "react-i18next";

export default function Threats() {
    const { apiUrl } = useContext(AuthContext);
    const { t } = useTranslation();

    const getThreats = async () => {
        const res = await axios(`${apiUrl}sentinelone/threats`, {
            method: "get",
            withCredentials: true
        })
        return res.data;
    }

    const threats = useQuery({
        queryKey: ["threats"],
        queryFn: getThreats,
    });

    return (
        <>
            {!threats.isLoading ? (
                <div className='cato-content-table'>
                    <Table
                        tableData={threats.data}
                        tableColumns={SentinelOneThreatscolumns}
                        rowComponent={RowThreats}
                    />
                </div>
            ) : (
                <Loader />
            )}
        </>
    );
}